// extracted by mini-css-extract-plugin
module.exports = {"container":"doublecheckEvaluationModal_container__1-FOU","modal":"doublecheckEvaluationModal_modal__u2O2g","btnContainer":"doublecheckEvaluationModal_btnContainer__1adPI"};